import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import { ITextCell } from '../../../../../../types/newbuildingsCompare';

export interface ITextCellProps {
  cell: ITextCell;
}

export const TextCell = ({ cell }: ITextCellProps): React.JSX.Element => {
  if (cell.data?.text) {
    return <Body1>{cell.data.text}</Body1>;
  }

  return <Body1 color="text-secondary-default">{cell.state.text ?? ''}</Body1>;
};
